export const queryKeys = {
  driver: 'driver',
};
